import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tw-mb-1 tw-block tw-text-xs" }
const _hoisted_3 = {
  key: 1,
  class: "tw-mb-1 tw-block tw-text-xs tw-text-slate-500"
}
const _hoisted_4 = {
  key: 2,
  class: "tw-flex tw-items-center tw-rounded tw-border tw-p-3"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 3,
  class: "tw-relative"
}
const _hoisted_7 = { class: "tw-relative" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  "data-testid": "upload-image-cta",
  class: "tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left hover:tw-bg-muted"
}
const _hoisted_10 = {
  key: 1,
  class: "tw-max-h-[500px] tw-overflow-y-auto"
}
const _hoisted_11 = { class: "tw-sticky tw-top-0 tw-flex tw-items-center tw-gap-2 tw-border-b tw-bg-white tw-px-3 tw-py-2 dark:tw-bg-black" }
const _hoisted_12 = {
  key: 1,
  class: "tw-space-y-6 tw-p-3"
}
const _hoisted_13 = {
  key: 0,
  class: "tw-py-12 tw-text-center tw-text-muted-foreground"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-sm" }, "No images available in brand kit", -1)
const _hoisted_15 = [
  _hoisted_14
]

import { BrandKit } from '@goldcast/api/backend';
import { IconUpload, IconBriefcase, IconChevronLeft, IconChevronRight } from '@tabler/icons-vue';
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';

import BrandKitGoToSelectPrompt from './BrandKitGoToSelectPrompt.vue';
import BrandKitImageGrid from './BrandKitImageGrid.vue';

import FilestackS3 from '@/components/core/Filestack/FilestackS3.vue';
import { CurrentOrganization } from '@/store/modules/org';
import { BrandKitAsset } from '@/studio/brandKit/store/types';
import { STATIC_ASSETS } from '@/utils/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageUploadButton',
  props: {
    label: { default: '' },
    subLabel: { default: '' },
    image: { default: '' },
    required: { type: Boolean, default: false },
    acceptedTypes: { default: () => ['.jpg', '.jpeg', '.webp', '.png', '.ico'] },
    imageValidation: { default: undefined },
    s3BucketPath: { default: '' },
    dropdownPosition: { default: 'left' }
  },
  emits: ["changeImageUrl"],
  setup(__props: any, { emit }) {

const props = __props;





const store = useStore();
const isMenuOpen = ref(false);
const isPickerOpen = ref(false);
const currentView = ref<'main' | 'brandKit'>('main');

const getCurrentOrg = computed<CurrentOrganization>(() => store.getters['org/getCurrentOrg']);
const selectedBrandKit = computed<BrandKit | null>(() => store.state.studioBrandKit.selectedBrandKit);

const orgS3Bucket = computed<string>(() => {
  return `${STATIC_ASSETS.SOCIAL_MEDIA_THUMBNAIL_PATH}/organization/${getCurrentOrg.value?.id}/`;
});

onMounted(async () => {
  await store.dispatch('studioBrandKit/ensureBrandKitsLoaded');
});

const logos = computed<BrandKitAsset[]>(() => {
  return (selectedBrandKit.value?.logos ?? []) as BrandKitAsset[];
});

const photographyElements = computed<BrandKitAsset[]>(() => {
  return (selectedBrandKit.value?.photography_elements ?? []) as BrandKitAsset[];
});

const designElements = computed<BrandKitAsset[]>(() => {
  return (selectedBrandKit.value?.design_elements ?? []) as BrandKitAsset[];
});

const hasAnyImage = computed<boolean>(() => {
  return logos.value.length > 0 || photographyElements.value.length > 0 || designElements.value.length > 0;
});

async function onFileUpload(files: any) {
  const { filesUploaded, filesFailed } = files;
  if (filesFailed?.length || filesUploaded?.length === 0) {
    await store.dispatch('studioToast/triggerToast', {
      msg: 'File Upload Failed',
      mode: 'error'
    });
    return;
  }

  const resourceKey = filesUploaded[0]?.key;
  if (!resourceKey) {
    store.dispatch('studioToast/triggerToast', {
      msg: 'File upload completed but no resource key was returned. Please try again.',
      mode: 'error'
    });
    return;
  }

  const url = `${STATIC_ASSETS.CLOUDFRONT_URL}/${resourceKey}`;
  emit('changeImageUrl', url);
  isMenuOpen.value = false;
}

function handleBrandKitImageSelected(imageUrl: string) {
  emit('changeImageUrl', imageUrl);
  isMenuOpen.value = false;
  currentView.value = 'main';
}

function handleRemoveImage() {
  emit('changeImageUrl', '');
}

function closeMenu() {
  if (isPickerOpen.value) {
    return;
  }
  isMenuOpen.value = false;
  currentView.value = 'main';
}

function handlePickerOpen() {
  isPickerOpen.value = true;
}

function handlePickerClose() {
  isPickerOpen.value = false;
}

function handleGoToSelectBrandKit() {
  isMenuOpen.value = false;
  currentView.value = 'main';
  store.commit('branding/setSection', { sectionId: 'brandKit', moduleId: 'selectBrandKit' });
}

return (_ctx: any,_cache: any) => {
  const _directive_studio_click_outside = _resolveDirective("studio-click-outside")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.label), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.subLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.subLabel), 1))
      : _createCommentVNode("", true),
    (_ctx.image)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.image,
            alt: "Uploaded Image",
            class: "tw-mr-2 tw-h-4 tw-object-contain"
          }, null, 8, _hoisted_5),
          _createElementVNode("div", {
            "data-testid": "remove-image-cta",
            class: "tw-cursor-pointer tw-text-xs tw-font-medium tw-text-black hover:tw-text-deep-orange-500",
            onClick: handleRemoveImage
          }, " Remove Image ")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("button", {
              "data-testid": "upload-image-cta",
              class: _normalizeClass(["tw-w-full tw-cursor-pointer tw-rounded tw-border tw-p-3 tw-text-left tw-text-xs tw-font-medium tw-text-black hover:tw-text-deep-orange-500", { 'tw-text-red-500': _ctx.required }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isMenuOpen.value = !isMenuOpen.value))
            }, " Add Image ", 2),
            (isMenuOpen.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([
            'tw-absolute tw-top-full tw-z-[100] tw-mt-1 tw-w-full tw-overflow-auto tw-rounded-md tw-bg-white tw-text-sm tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none dark:tw-bg-black',
            _ctx.dropdownPosition === 'right' ? 'tw-right-0' : 'tw-left-0',
            currentView.value === 'brandKit' && 'tw-max-h-[500px]'
          ])
                }, [
                  (currentView.value === 'main')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(FilestackS3, {
                          s3path: _ctx.s3BucketPath || orgS3Bucket.value,
                          acceptedTypes: _ctx.acceptedTypes,
                          imageValidation: _ctx.imageValidation,
                          replaceSpacesInFileName: true,
                          onFileuploaded: onFileUpload,
                          onOnOpen: handlePickerOpen,
                          onClose: handlePickerClose,
                          onCancelUpload: handlePickerClose
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_unref(IconUpload), { class: "tw-h-4 tw-w-4" }),
                              _createTextVNode(" Upload Image ")
                            ])
                          ]),
                          _: 1
                        }, 8, ["s3path", "acceptedTypes", "imageValidation"]),
                        _createElementVNode("button", {
                          class: "tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left hover:tw-bg-muted",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (currentView.value = 'brandKit'))
                        }, [
                          _createVNode(_unref(IconBriefcase), { class: "tw-h-4 tw-w-4" }),
                          _createTextVNode(" Brand Kit "),
                          _createVNode(_unref(IconChevronRight), { class: "tw-ml-auto tw-h-4 tw-w-4" })
                        ])
                      ]))
                    : (currentView.value === 'brandKit')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                              class: "hover:tw-text-primary tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-text-muted-foreground",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (currentView.value = 'main'))
                            }, [
                              _createVNode(_unref(IconChevronLeft), { class: "tw-h-4 tw-w-4" }),
                              _createTextVNode(" Back ")
                            ])
                          ]),
                          (!selectedBrandKit.value)
                            ? (_openBlock(), _createBlock(BrandKitGoToSelectPrompt, {
                                key: 0,
                                class: "tw-m-3",
                                onGoToSelectBrandKit: handleGoToSelectBrandKit
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(BrandKitImageGrid, {
                                  title: "Logos",
                                  images: logos.value,
                                  defaultAlt: "Logo",
                                  imageClass: "tw-w-full tw-h-full tw-object-contain tw-p-2",
                                  overlayClass: "tw-absolute tw-inset-0 tw-bg-black/0 group-hover:tw-bg-black/10 tw-transition-colors tw-flex tw-items-center tw-justify-center",
                                  onSelect: handleBrandKitImageSelected
                                }, null, 8, ["images"]),
                                _createVNode(BrandKitImageGrid, {
                                  title: "Photography",
                                  images: photographyElements.value,
                                  defaultAlt: "Brand kit asset",
                                  imageClass: "tw-w-full tw-h-full tw-object-cover",
                                  overlayClass: "tw-absolute tw-inset-0 tw-bg-black/0 group-hover:tw-bg-black/20 tw-transition-colors tw-flex tw-items-center tw-justify-center",
                                  onSelect: handleBrandKitImageSelected
                                }, null, 8, ["images"]),
                                _createVNode(BrandKitImageGrid, {
                                  title: "Design Elements",
                                  images: designElements.value,
                                  defaultAlt: "Design Element",
                                  imageClass: "tw-w-full tw-h-full tw-object-cover",
                                  overlayClass: "tw-absolute tw-inset-0 tw-bg-black/0 group-hover:tw-bg-black/20 tw-transition-colors tw-flex tw-items-center tw-justify-center",
                                  onSelect: handleBrandKitImageSelected
                                }, null, 8, ["images"]),
                                (!hasAnyImage.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                                  : _createCommentVNode("", true)
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ])), [
            [_directive_studio_click_outside, closeMenu]
          ])
        ]))
  ]))
}
}

})